import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, Tooltip } from "@mui/material";

interface CopyButtonProps {
  value: string;
  fieldId: string;
  copiedField: string | null;
  onCopy: (value: string, fieldId: string) => void;
}

export default function CopyButton({ value, fieldId, copiedField, onCopy }: CopyButtonProps) {
  return (
    <Tooltip title={copiedField === fieldId ? "Copied!" : "Copy"}>
      <IconButton size="small" onClick={() => onCopy(value, fieldId)}>
        {copiedField === fieldId ? (
          <CheckIcon fontSize="small" color="success" />
        ) : (
          <ContentCopyIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
}
